import React from "react";
import {ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText} from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PrintIcon from "@material-ui/icons/Print";
import WorkableIcon from "components/button/WorkableIcon";
import Tr from "translations/Translations";
import Typography from "components/Typography";
import {makeStyles} from "@material-ui/styles";
import PropTypes from "prop-types";
import WorkableIconShareButton from "components/button/WorkableIconShareButton";

const useStyle = makeStyles(theme => ({
    italic: {
        fontStyle: 'italic',
        fontSize: '0.75rem'
    }
}))

const PaperLink = (
    {
        paper,
        paperWorking,
        editable,
        paperClick,
        showShare,
        shareClick
    }) => {

    const classes = useStyle();

    return (
        <>
            <ListItem button onClick={() => paperClick(paper)} disabled={!editable || (paper.available && paper.waiting) || (!paper.available && !paper.salesModule)}>
                <ListItemIcon>
                    <WorkableIcon
                        Icon={(!paper.waiting && paper.available && !!paper.customPopup) ? ExitToAppIcon : PrintIcon}
                        working={paperWorking === paper.paperId}/>
                </ListItemIcon>
                <ListItemText>
                    {paper.name}
                    {(paper.available && paper.waiting) &&
                        <Typography component='span' className={classes.italic}> {" (" + Tr('papers_generator_paper_waiting') + ")"}</Typography>}
                </ListItemText>
                {showShare &&
                    <ListItemSecondaryAction>
                        <WorkableIconShareButton
                            edge="end"
                            disabled={paper.waiting || !paper.available || !!paperWorking}
                            onClick={() => shareClick(paper)}
                        />
                    </ListItemSecondaryAction>
                }
            </ListItem>

        </>)
}

PaperLink.propTypes = {
    paper: PropTypes.shape({
        paperId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        customPopup: PropTypes.string,
        available: PropTypes.bool.isRequired,
        waiting: PropTypes.bool.isRequired,
    }),
    paperWorking: PropTypes.string,
    paperClick: PropTypes.func.isRequired,
    showShare: PropTypes.bool.isRequired,
    shareClick: PropTypes.func.isRequired,

}

export default PaperLink;